/* eslint-disable no-use-before-define */
import router from './router';

const auth = {};


/**
 * If the user isn't logged in, redirect them to login component
 */
auth.requireLogin = () => {
  if (getCookie('loggedIn') === 'true') return;

  router.push('/login');

  /**
   * Get a cookie value by its name
   *
   * @param  {str} name
   * @return {str}
   */
  // eslint-disable-next-line consistent-return
  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }
};


/**
 * Register that a login has occurred by triggering a "loggedIn" cookie,
 * then redirect to homepage
 */
auth.registerLogin = () => {
  document.cookie = 'loggedIn=true';
  router.push('/');
};


export default auth;



// WEBPACK FOOTER //
// ./src/auth.js